import { GetStaticProps } from "next";
import React, { useEffect } from "react";
import { MetaTagsComp } from "../components/MetaTagsComp";
import UpcomingEvent from "../components/UpcomingEvents/UpcomingEvents";
import fetchUtil from "../utils/fetchUtil";
import { CACHE_REVALIDATE_24H } from "../utils/constants";

const Events: React.FC = (props: any) => {
  const { meta } = props.pageData ?? {};
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#20115b");
    customStyle.setProperty("--navbar-menu-color", "#ffff");
  }, []);
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <UpcomingEvent {...props} />
    </>
  );
};

// Fetches a CMS endpoint, returning `fallback` instead of throwing so a missing
// or failed response never breaks the static build.
const safeFetch = async (url: string, fallback: any) => {
  try {
    const data = await fetchUtil(url, "GET", {}, "", false);
    return data ?? fallback;
  } catch (error) {
    return fallback;
  }
};

export const getStaticProps: GetStaticProps = async () => {
  const base = process.env.NEXT_PUBLIC_API_BASE_URL;
  const [pageData, eventsData, countriesData, studyDestinationList, citiesData] = await Promise.all([
    safeFetch(`${base}/events-landing`, {}),
    safeFetch(`${base}/events?_sort=startDate:ASC&_start=0&_limit=20&showInTable=true`, {}),
    safeFetch(`${base}/countries`, []),
    safeFetch(`${base}/events/study-destinations`, []),
    safeFetch(`${base}/events/cities`, []),
  ]);

  if (Array.isArray(countriesData)) {
    countriesData.sort((countryA: any, countryB: any) => countryA.id - countryB.id);
  }

  return {
    props: {
      pageData,
      countriesData,
      eventsData,
      studyDestinationList,
      citiesData,
    },
    revalidate: CACHE_REVALIDATE_24H,
  };
};

export default Events;
